import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  Grid,
  Container,
  FormHelperText,
  InputAdornment,
  InputLabel,
  Chip,
  Box,
  CircularProgress,
  Autocomplete
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackArrow from '../assets/back-arrow.svg';
import ProfileIcon from '../assets/profile-icon.svg';
import EditIcon from '../assets/edit-icon.svg';
import OtherInformation from '../assets/other-information.svg';
import ProfileImage from '../assets/profile-information-image.png';
import RelationshipImg from '../assets/relationship-info.png';
import DocumentIcon from '../assets/document-icon.png';
import DeleteBin from "../assets/delete-bin.svg";
import ExitIcon from '../assets/exit-icon.svg'
import axios from 'axios';
import { useSnackbar } from 'notistack';
import PostRequest from '../components/apiConnections/postRequest';
import GetRequest from '../components/apiConnections/getRequest';
import MuiPhoneNumber from 'material-ui-phone-number';
import CalendarTodayIcon from '../assets/calender-icon-select.svg'
import { industryArray } from '../components/constant/industryConstant';
import defaultLogo from '../assets/companyLogo.jpg';
import Upload from "../assets/Vectorplus.svg";
import ModalDialog from './ModalDialog';
import Delete from "../assets/delete.svg";

function AddNewVendorByClient(props) {
  const location = useLocation();
  const { fillDetails } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const roleId = localStorage.getItem("roleId");
  const { domain } = location?.state || props;
  const { vendorStatus: status } = location?.state || props;
  const { jsonAvailableData: jsonAvailable } = location?.state || props;
  const handleClose = props.handleClose || null;
  const [errors, setErrors] = useState({});
  const [docErrors, setDocErrors] = useState({});
  const [availableDocument, setAvailableDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [inputValue, setInputValue] = useState('');

  const [getDataSensitivityRisk, setGetDataSensitivityRisk] = useState(30);
  const [getDependencyLevelRisk, setGetDependencyLevelRisk] = useState(20);
  const [getAccessLevelRisk, setGetAccessLevelRisk] = useState(25);
  const [getComplianceLevelRisk, setGetComplianceLevelRisk] = useState(25);
  const [logoAvailable, setLogoAvailable] = useState(false);
  const [finalRelationshipRisk, setFinalRelationshipRisk] = useState();
  const [showRiskTag, setShowRiskTag] = useState(false);
  const allTabsInformationRef = useRef(null);
  const [showExitModal, setShowExitModal] = useState(false)
  const [formData, setFormData] = useState({
    domain: domain,
    logo: `${process.env.REACT_APP_GET_LOGO_BY_THIRD_API}/${domain}`,
    name: '',
    industry: '',
    Subindustry: '',
    numberOfEmployees: '',
    linkedin: '',
    country: '',
    address: '',
    description: '',
    contactInformation: [{ firstName: '', lastName: '', email: '', mobile: '', isPrimary: true }],
    acceptableRisk: '',
    customTags: [],
    contractDeadline: '',
    documents: [{ documentType: '', isUpload: true, documentFile: null, type: '' }],
    dataSensitivity: [],
    accessLevel: [],
    dependencyLevel: [],
    complianceLevel: [],
    vendorStatus: status,
    revenue: ''
  });

  // useEffect(() => {
  //   const flagButton = document.querySelector('.MuiPhoneNumber-flagButton');

  //   if (!flagButton) return;

  //   const handleDropdownToggle = () => {
  //     // Wait a moment to allow dropdown to open
  //     setTimeout(() => {
  //       const dropdown = document.querySelector('.tttttt'); // Adjust if needed

  //       console.log(dropdown, "dropdown")
  //       if (dropdown) {
  //         document.body.style.overflow = 'hidden';
  //         document.documentElement.style.overflow = 'hidden';
  //       }
  //     }, 100);
  //   };

  //   const handleClickOutside = (event) => {
  //     const dropdown = document.querySelector('.tttttt');
  //     const flagBtn = document.querySelector('.MuiPhoneNumber-flagButton');

  //     if (
  //       dropdown &&
  //       !dropdown.contains(event.target) &&
  //       !flagBtn.contains(event.target)
  //     ) {
  //       document.body.style.overflow = '';
  //       document.documentElement.style.overflow = '';
  //     }
  //   };

  //   flagButton.addEventListener('click', handleDropdownToggle);
  //   document.addEventListener('click', handleClickOutside);

  //   // Clean up
  //   return () => {
  //     flagButton.removeEventListener('click', handleDropdownToggle);
  //     document.removeEventListener('click', handleClickOutside);
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = '';
  //   };
  // }, []);


  const dependencyLevelArr = [
    "Low (Easily Replaceable)",
    "Moderate (Some Impact if Replaced)",
    "High (Significant Impact if Replaced)",
    "Critical (Not Easily Replaceable)",
  ]
  const dataSensitivityOptions = [
    "Non-sensitive",
    "Internal business data",
    "Personal data (PII)",
    "Customer data",
    "Financial data",
    "Intellectual property",
    "Legal data",
    "Confidential business plans",
    "Health data",
  ];
  const accessLevelOptions = [
    "No access",
    "Limited access",
    "Read-Write access",
    "Operational access",
    "Full access"
  ];
  const complianceOptions = [
    "No specific compliance requirements",
    "Compliance with general standards (e.g., ISO 9001, ISO 27001)",
    "Compliance with industry regulations (e.g., PCI DSS, SOX, FERPA)",
    "Compliance with strict regulations (e.g., GDPR, HIPAA, CCPA, FISMA)"
  ]
  // const acceptableRiskArr = Array.from({ length: 100 }, (_, i) => i + 1);

  const subIndustries = industryArray.find((industry) => industry.industryType === formData.industry)
    ?.subIndustries || [];
  useEffect(() => {
    getCompaniesDetails();
    getDocuments();
    checkIfLogoFetched()
  }, [])

  useEffect(() => {

    setFinalRelationshipRisk((getDataSensitivityRisk +
      getAccessLevelRisk +
      getDependencyLevelRisk +
      getComplianceLevelRisk))?.toFixed(2);

  }, [getDataSensitivityRisk, getAccessLevelRisk, getDependencyLevelRisk, getComplianceLevelRisk]);



  const getCompaniesDetails = async () => {
    try {
      // let logo = null;
      axios.get(`${process.env.REACT_APP_THIRD_PARTY_API_TO_FEATCH_VENDOR_DETAILS}/${domain}?token=${process.env.REACT_APP_THIRD_PARTY_API_TO_TOKEN}`).then(res => {
        const data = res?.data;
        if (data?.domainName) {
          setFormData((prev) => ({
            ...prev,
            // logo: logo || '',
            name: data.name || '',
            // industries: data.industryMain || '',
            numberOfEmployees: data.totalEmployees || '',
            linkedin: data.socialNetworks?.linkedin || '',
            country: data.country?.name || '',
            description: data.description || '',
            address: data.city?.name || '',
            revenue: data?.revenue || ''
          }));
        }
      }).catch(err => {
        console.log(err)
      })
    } catch (error) {
      console.error("Error fetching vendor data:", error);
    }
  }
  const getDocuments = async () => {
    try {
      const refreshToken = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
        {},
        {},
        "refreshToken"
      );
      if (refreshToken) {
        await GetRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_DOCUMENT_TYPE}`,
          {}
        )
          .then((response) => {
            setAvailableDocuments(response.data.data);
          })
          .catch((err) => {
            enqueueSnackbar(err.message, { variant: 'error' });

          })
      } else {
        console.log("Refresh token is expaired!");
      }
    }
    catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  const handleChange = (e) => {
    // e.preventDefault();
    const { name, value, type, checked } = e.target;
    if (name === "industry") {
      formData.Subindustry = "";
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: ''
    }));

  };

  const handleContactChange = (index, e) => {
    const { name, value } = e.target;
    const contacts = [...formData.contactInformation];
    contacts[index][name] = value;
    contacts.forEach((contact, i) => {
      contact.isPrimary = i === 0;
    });
    setFormData((prev) => ({
      ...prev,
      contactInformation: contacts
    }));
    setErrors((prev) => ({
      ...prev,
      [`contact-${index}-${name}`]: ''
    }));
  };

  const validateForDocument = () => {
    const docErrors = {};
    // Validate documents
    formData.documents.forEach((document, index) => {
      if (!document.documentType) {
        docErrors[`document-${index}-type`] = '*Please select a document type';
      }
      if (!document.documentFile && document.isUpload !== false) {
        docErrors[`document-${index}-file`] = '*Please upload a document file';
      }
    });
    setDocErrors(docErrors);
    return Object.keys(docErrors).length === 0;
  };

  const handleAddContact = () => {
    setFormData((prev) => ({
      ...prev,
      contactInformation: [...prev.contactInformation, { firstName: '', lastName: '', email: '', mobile: '', isPrimary: false }]
    }));
  };

  const handleDeleteContact = (index) => {
    const updatedContacts = formData.contactInformation.filter((_, i) => i !== index);
    setFormData({ ...formData, contactInformation: updatedContacts });
  };

  const handleDeletedOC = (index) => {
    const updatedDOC = formData.documents.filter((_, i) => i !== index);
    setFormData({ ...formData, documents: updatedDOC });
    setDocErrors({})
  };

  // const theme = localStorage.getItem("theme");

  const formSubmit = async (e) => {
    e.preventDefault();
  }

  const handleSave = async (e) => {

    setLoading(true);
    if (validateFields() && validateForDocument()) {
      let payload = new FormData();
      if (formData.logo instanceof File) {
        let uploadLogoAPI = await uploadCustomLogo();
        if (uploadLogoAPI.error) return;
        else if (uploadLogoAPI.url) payload.append("logo", uploadLogoAPI.url)
      } else {
        payload.append("logo", formData.logo || null)
      }
      const documents = [];

      for (let item of formData.documents) {
        if (item.documentFile && item.isUpload) payload.append("documentFiles", item.documentFile)
        documents.push({
          type: item.type,
          documentType: item.documentType,
          isRequest: item.isRequest,
          isUpload: item.isUpload,
          documentName: item.documentFile ? item.documentFile?.name : null
        })
      }
      // let getIndustries = formData.industry ? formData.industry?.split(",") : [];
      // let getSubIndustries = formData.Subindustry ? formData.Subindustry?.split(",") : [];
      const industries = [formData.industry];
      const subIndustries = [formData.Subindustry];
      const contactPersonList = formData.contactInformation.map(cp => ({
        ...cp,
        email: `${cp.email}@${domain}`
      }));
      payload.append("domain", domain)
      if (!props.domain) {
        if (roleId === "2") payload.append("clientEmail", location.state?.clientEmail)
        else payload.append("clientEmail", localStorage.getItem("userEmail"))

        payload.append("vendorStatus", status)
      }
      payload.append("name", formData.name)
      payload.append("industries", JSON.stringify(industries))
      payload.append("Subindustry", JSON.stringify(subIndustries))
      payload.append("numberOfEmployees", formData.numberOfEmployees)
      payload.append("linkedIn", formData.linkedin)
      payload.append("country", formData.country)
      payload.append("address", formData.address)
      payload.append("description", formData.description)
      payload.append("revenue", formData.revenue)
      payload.append("contactInformation", JSON.stringify(contactPersonList))
      payload.append("relationships", JSON.stringify({
        dataSensitivity: formData.dataSensitivity,
        accessLevel: formData.accessLevel,
        dependencyLevel: formData.dependencyLevel,
        complianceLevel: formData.complianceLevel
      }))
      payload.append("acceptableRisk", formData.acceptableRisk)
      payload.append("customTags", JSON.stringify(formData.customTags))
      payload.append("contractDeadline", formData.contractDeadline)
      payload.append("documents", JSON.stringify(documents));
      payload.append("fillDetails", fillDetails);
      // console.log("payload", payload);
      if (props.domain) {
        props.handleSuccess(payload)
        return;
      }
      try {
        console.log("triggred")
        const refreshToken = await PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
          {},
          {},
          "refreshToken"
        );
        let endPoint = roleId === "2" ? process.env.REACT_APP_ADD_CLIENT_VENDOR_BY_ADMIN :
          process.env.REACT_APP_ADD_VENDOR_DETAILS
        if (refreshToken) {
          await PostRequest(
            `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${endPoint}`,
            payload
          )
            .then((resChart) => {
              enqueueSnackbar('Vendor added successfully', { variant: 'success' });
              setTimeout(() => {
                if (roleId === "2") {
                  navigate(`/admin/client-details/${location.state?.clientId}`, { state: { tab: 1 } })
                } else {
                  if (jsonAvailable) {
                    navigate(`/dashboard/vendorDetails/${domain}`);
                  } else navigate(`/dashboard/vendors`);
                }
              }, 2000)
              setLoading(false);
            })
            .catch((errChart) => {
              enqueueSnackbar(errChart.message, { variant: 'error' });
              setLoading(false)
            })
        } else {
          setLoading(false);
        }
      }
      catch (error) {
        enqueueSnackbar(error.message, { variant: 'error' });
        setLoading(false);
      }
    } else {
      enqueueSnackbar("Please provide valid details", { variant: 'error' });
      setLoading(false);
    }
  };


  const handleImageChange = async (e) => {
    e.preventDefault()
    const file = e.target.files[0];
    if (!file?.type || file?.type.split("/")[0] !== "image") {
      enqueueSnackbar("Please upload image type only", { variant: 'error' });
      return;
    }
    setFormData({ ...formData, logo: file })
  }

  const uploadCustomLogo = async () => {
    if (!formData?.logo?.type || formData?.logo?.type.split("/")[0] !== "image") {
      enqueueSnackbar("Please upload valid image of logo", { variant: 'error' });
      return { error: true, url: null }
    }
    let payload = new FormData();
    payload.append("domain", domain)
    payload.append("logo", formData?.logo)
    try {
      const uploadLogo = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_UPLOAD_VENDOR_DOMAIN_LOGO}`,
        payload
      )
      if (uploadLogo.data.code === 200) return { error: false, url: uploadLogo.data.data?.fileUrl }
      else {
        enqueueSnackbar(uploadLogo.message, { variant: 'error' });
        return { error: true, url: null }
      }
    }
    catch (error) {
      enqueueSnackbar(error.message || "error while uploading logo", { variant: 'error' });
      console.log(error)
    }
  }

  const checkIfLogoFetched = async () => {
    const img = new Image();
    img.src = `${process.env.REACT_APP_GET_LOGO_BY_THIRD_API}/${domain}`;
    img.onload = () => {
      setLogoAvailable(true)
    }
  }

  const getCurrentDate = () => {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    let day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const calculateRelationShipRisk = (value, key) => {
    if (value && key) {
      if (key === "dataSensitivity") {
        switch (value) {
          case "Non-sensitive":
            setGetDataSensitivityRisk(100 * (30 / 100));
            break;
          case "Internal business data":
            setGetDataSensitivityRisk(90 * (30 / 100));
            break;
          case "Personal data (PII)":
            setGetDataSensitivityRisk(70 * (30 / 100));
            break;
          case "Customer data":
            setGetDataSensitivityRisk(60 * (30 / 100));
            break;
          case "Financial data":
            setGetDataSensitivityRisk(40 * (30 / 100));
            break;
          case "Intellectual property":
            setGetDataSensitivityRisk(40 * (30 / 100));
            break;
          case "Health data":
            setGetDataSensitivityRisk(0 * (30 / 100));
            break;
          case "Legal data":
            setGetDataSensitivityRisk(40 * (30 / 100));
            break;
          case "Confidential business plans":
            setGetDataSensitivityRisk(40 * (30 / 100));
            break;
          default:
            setGetDataSensitivityRisk(0);
        }
      }

      if (key === "accessLevel") {
        switch (value) {
          case "No access":
            setGetAccessLevelRisk(100 * (25 / 100));
            break;
          case "Limited access":
            setGetAccessLevelRisk(90 * (25 / 100));
            break;
          case "Read-Write access":
            setGetAccessLevelRisk(70 * (25 / 100));
            break;
          case "Operational access":
            setGetAccessLevelRisk(40 * (25 / 100));
            break;
          case "Full access":
            setGetAccessLevelRisk(0 * (25 / 100));
            break;
          default:
            setGetAccessLevelRisk(25);
        }
      }

      if (key === "dependencyLevel") {
        switch (value) {
          case "Low (Easily Replaceable)":
            setGetDependencyLevelRisk(100 * (20 / 100));
            break;
          case "Moderate (Some Impact if Replaced)":
            setGetDependencyLevelRisk(70 * (20 / 100));
            break;
          case "High (Significant Impact if Replaced)":
            setGetDependencyLevelRisk(40 * (20 / 100));
            break;
          case "Critical (Not Easily Replaceable)":
            setGetDependencyLevelRisk(0);
            break;
          default:
            setGetDependencyLevelRisk(20);
        }
      }

      if (key === "complianceLevel") {
        switch (value) {
          case "No specific compliance requirements":
            setGetComplianceLevelRisk(100 * (25 / 100));
            break;
          case "Compliance with general standards (e.g., ISO 9001, ISO 27001)":
            setGetComplianceLevelRisk(70 * (25 / 100));
            break;
          case "Compliance with industry regulations (e.g., PCI DSS, SOX, FERPA)":
            setGetComplianceLevelRisk(40 * (25 / 100));
            break;
          case "Compliance with strict regulations (e.g., GDPR, HIPAA, CCPA, FISMA)":
            setGetComplianceLevelRisk(0 * (25 / 100));
            break;
          default:
            setGetComplianceLevelRisk(25);
        }
      }
    }
  }
  const handleCheckboxChange = (event, key) => {
    setShowRiskTag(true);
    const { name, value } = event.target;
    calculateRelationShipRisk(value, key);
    setFormData((prevData) => ({
      ...prevData,
      [key]: [value],
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: ''
    }));
  };

  const validateFields = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = '*Please enter Business Name';
    if (!formData.industry) newErrors.industry = '*Please select Industry.';
    if (!formData.Subindustry) newErrors.Subindustry = '*Please select Subindustry.';
    if (!formData.acceptableRisk ||
      formData.acceptableRisk < 0
      || formData.acceptableRisk > 100
    ) newErrors.acceptableRisk = '*please enter acceptable risk between 0 to 100';

    // if (!formData.country) newErrors.country = '*Please enter Country.';
    // if (!formData.numberOfEmployees) newErrors.numberOfEmployees = '*Please enter Number Of Employees.';
    // if (!formData.contractDeadline) newErrors.contractDeadline = '*please select Contract Deadline';

    // Validate contacts
    formData.contactInformation.reduce((acc, contact, index) => {
      if (!contact.firstName || contact.firstName?.length < 3) {
        acc[`contact-${index}-firstName`] = '*Please enter Contact First Name, atleast 3 character';
      }
      if (!contact.lastName) {
        acc[`contact-${index}-lastName`] = '*Please enter Contact Last Name, atleast 3 character';
      }
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex = /^[a-z0-9._+-]+$/;

      if (!contact.email) {
        acc[`contact-${index}-email`] = '*Please enter Contact Email.';
      }
      else if (!emailRegex.test(contact.email)) {
        acc[`contact-${index}-email`] = "*Invalid email format";
      }

      // console.log("emailRegex.test(contact.email)", emailRegex.test(contact.email));
      return acc;
    }, newErrors);
    // if(finalRelationshipRisk<=0) newErrors.relationshipError = '*please select risk check boxes'
    // console.log("newErrors", newErrors);

    // console.log("formData", formData.dataSensitivity);
    // console.log("formData", formData.dependencyLevel);
    // console.log("formData", formData.complianceLevel);
    // console.log("formData", formData.accessLevel);
    // Set Risk relationship only after 2 step 
    if (currentStep >= 1) {
      if (Array.isArray(formData.dataSensitivity) && formData.dataSensitivity?.length === 0) newErrors.dataSensitivity = '*please select data sensitivity risk';
      if (Array.isArray(formData.dependencyLevel) && formData.dependencyLevel?.length === 0) newErrors.dependencyLevel = '*please select dependency level risk';
      if (Array.isArray(formData.complianceLevel) && formData.complianceLevel?.length === 0) newErrors.complianceLevel = '*please select compliance level risk';
      if (Array.isArray(formData.accessLevel) && formData.accessLevel?.length === 0) newErrors.accessLevel = '*please select access level risk';
    }
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const validateFileType = (file) => {
    const validFileTypes = [
      'application/pdf',
      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      // 'application/vnd.ms-excel' // .xls
    ];

    return file ? validFileTypes.includes(file.type) : false;
  };


  const handleFileChange = (e, index) => {
    const file = e.target.files[0];

    if (validateFileType(file)) {
      const updatedDocuments = [...formData.documents];
      updatedDocuments[index].documentFile = file;
      setFormData((prev) => ({ ...prev, documents: updatedDocuments }));

      setDocErrors((prevErrors) => ({
        ...prevErrors,
        [`document-${index}-file`]: ''
      }));
    } else {
      // Reset the file input
      e.target.value = '';

      // Set error message for invalid file type
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`document-${index}-file`]: 'Only PDF files are allowed'
      }));
    }
  };
  const handleNext = () => {
    if (validateFields()) {
      if (currentStep < 2) {
        setCurrentStep(currentStep + 1);
        // Scroll to the div with class 'all-tabsinformation'
        if (allTabsInformationRef.current) {
          allTabsInformationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      // Scroll to the div with class 'all-tabsinformation'
      if (allTabsInformationRef.current) {
        allTabsInformationRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = inputValue.trim();
      if (value && !formData.customTags.includes(value)) {
        setFormData(prev => ({
          ...prev,
          customTags: [...prev.customTags, value]
        }));
      }
      setInputValue('');
    }
  };

  const handleDelete = (tagToDelete) => {
    setFormData(prev => ({
      ...prev,
      customTags: prev.customTags.filter((tag) => tag !== tagToDelete)
    }));
  };

  const ExitModalContent = () => {
    return (
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        <img src={ExitIcon} alt="icon" />
        <h2 className="send-assessments">
          This action will discard all entered vendor data,
          Are you sure you want to exit ?
        </h2>
      </Typography>
    );
  };
  return (
    <>
      <Helmet>
        <title>Genesis Platform</title>
      </Helmet>
      <form onSubmit={(e) => formSubmit(e)}>
        <Container maxWidth={false} className="max-w-left">
          <Grid container spacing={3} className="ipad-space">
            <Grid item xs={12} md={12} lg={12}>
              <Typography variant="h4" sx={{ mb: 2 }}>
                <span className='backlink'>
                  <img src={BackArrow} alt='icon' onClick={currentStep > 0 ? () => handleBack() : () => setShowExitModal(true)} /> Add New Vendor
                </span>
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <div>
                <div className='heading-add-vendor'>
                  <p>New Registration ( Complete this basic information)</p>
                </div>
                <div className='all-tabsinformation' ref={allTabsInformationRef}>
                  <div className='three-steps-tabs add-newvendor-steps'>
                    <div className={`select-steps ${currentStep >= 0 ? 'behind-line activeprofile' : ''}`}>
                      <div className='steps-image'>
                        <img src={ProfileImage} alt='icon' />
                      </div>
                      <p>Profile Information </p>
                    </div>
                    <div className={`select-steps behind-line ${currentStep >= 1 ? 'behind-line' : ''} ${currentStep >= 1 ? 'activeprofile' : ''}`}>
                      <div className='steps-image '>
                        <img src={RelationshipImg} alt='icon' />
                      </div>
                      <p>Relationship Information</p>
                    </div>
                    <div className={`select-steps ${currentStep >= 2 ? 'activeprofile' : ''}`}>
                      <div className='steps-image'>
                        <img src={DocumentIcon} alt='icon' />
                      </div>
                      <p>Document Information</p>
                    </div>
                  </div>

                  {/*First Tab Start*/}
                  {currentStep === 0 && (
                    <div className='information-tab-heading'>
                      <p><img src={ProfileIcon} width={45} alt='profile icon' /> Profile Information </p>
                      <img src={EditIcon} alt="icon" />
                    </div>
                  )}
                  <div className='input-information'>
                    {currentStep === 0 && (
                      <>
                        <div className='vendor-logoinformation'>
                          <div className='logo-vender-new'>
                            <div className='add-newvendor-logo-here'>
                              <img
                                src={typeof formData.logo === "string" ? formData.logo : URL.createObjectURL(formData.logo)}
                                alt="icon"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = defaultLogo;
                                }}
                              />
                            </div>
                            {!logoAvailable ? <>
                              <Button
                                htmlFor="file-upload-logo"
                                size="small"
                                variant="contained"
                                color="primary"
                                component="label"
                                className="upload-new-plus reduce-padding"
                                title="Select Image"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <img src={Upload} alt="icon" />
                                  <span>Upload Logo</span>
                                </div>
                              </Button>
                              <input
                                id="file-upload-logo"
                                type="file"
                                accept="image/jpg, image/png, image/PNG, image/jpeg, image/JPG, image/JPEG"
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                              />
                            </> : null}
                          </div>
                          <div className='right-input-fields'>
                            <div className='flex-inputcontrol-full'>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  name="name"
                                  label="Business Name"
                                  className='add-vender-input-design'
                                  value={formData.name}
                                  onChange={(e) => handleChange(e)}
                                  onBlur={(e) => handleChange(e)}
                                  required
                                  maxLength={80}
                                  autoComplete='new-password'
                                  inputProps={{ autoComplete: 'new-password' }}
                                  error={!!errors[`name`]}
                                  helperText={errors[`name`]}
                                />
                              </FormControl>

                              {/* Industry Selection  */}
                              <Autocomplete
                                freeSolo
                                options={industryArray.map((industry) => industry.industryType)} // Predefined options
                                value={formData.industry}
                                onChange={(event, newValue) => {
                                  handleChange({ target: { name: "industry", value: newValue } });
                                }}
                                onInputChange={(event, newInputValue) => {
                                  handleChange({ target: { name: "industry", value: newInputValue } });
                                }}
                                className='select-industry-value'
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select or Enter Industry"
                                    variant="outlined"
                                    error={!!errors.industry}
                                    helperText={errors.industry}

                                    inputProps={{
                                      ...params.inputProps,
                                    }}
                                  />
                                )}
                              />

                              {/* <FormControl fullWidth>
                                <InputLabel id="industry-label" shrink={formData.industry !== ""}
                                  sx={{
                                    '&.Mui-focused': {
                                      color: formData.industry ? 'primary.main' : 'rgba(255, 255, 255, 0.7)',
                                    },
                                  }}>Select Industry</InputLabel>
                                <Select
                                  labelId="industry-label"
                                  id="industry"
                                  name="industry"
                                  value={formData.industry}
                                  onChange={(e) => handleChange(e)}
                                  required
                                  label="industry-label"
                                  error={!!errors.industry}
                                  helperText={errors.industry}
                                  className='add-vender-select-value'>
                                  <MenuItem value="" disabled>Industry type  </MenuItem>
                                  {industryArray.map((industry) => (
                                    <MenuItem key={industry.industryType} value={industry.industryType}>{industry.industryType}</MenuItem>
                                  ))}
                                  <MenuItem value="Other">Other</MenuItem>
                                </Select>
                                {!!errors.industry && (
                                  <FormHelperText sx={{ color: 'red!important' }}>{errors.industry}</FormHelperText>
                                )}
                              </FormControl> */}
                              {/* Show input field when 'Other' is selected */}


                              {/* Sub-Industry Selection  */}
                              <Autocomplete
                                freeSolo
                                options={subIndustries} // Predefined subindustry options
                                value={formData.Subindustry}
                                onChange={(event, newValue) => {
                                  handleChange({ target: { name: "Subindustry", value: newValue } });
                                }}
                                onInputChange={(event, newInputValue) => {
                                  handleChange({ target: { name: "Subindustry", value: newInputValue } });
                                }}
                                className='select-industry-value'
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select or Enter Sub-Industry"
                                    variant="outlined"
                                    error={!!errors.Subindustry}
                                    helperText={errors.Subindustry}
                                  // inputProps={{
                                  //   ...params.inputProps,
                                  //   maxLength: 50, // Restrict maximum input length
                                  // }}
                                  />
                                )}
                              />


                              {/* <FormControl fullWidth>
                                <InputLabel id="subIndustry-label" shrink={formData.Subindustry !== ""}
                                  sx={{
                                    '&.Mui-focused': {
                                      color: formData.Subindustry ? 'primary.main' : 'rgba(255, 255, 255, 0.7)',
                                    },
                                  }}>Select Subindustry</InputLabel>
                                <Select
                                  labelId="Subindustry-label"
                                  id="Subindustry"
                                  name="Subindustry"
                                  value={formData.Subindustry}
                                  onChange={(e) => handleChange(e)}
                                  required
                                  label="Subindustry-label"
                                  error={!!errors.Subindustry}
                                  helperText={errors.Subindustry}
                                  className='add-vender-select-value'>
                                  <MenuItem value="" disabled> Subindustry type </MenuItem>
                                  {subIndustries.map((industry) => (
                                    <MenuItem key={industry} value={industry}>{industry}</MenuItem>
                                  ))}
                                  <MenuItem value="Other">Other</MenuItem>
                                </Select>
                                {!!errors.Subindustry && (
                                  <FormHelperText sx={{ color: 'red!important' }}>{errors.Subindustry}</FormHelperText>
                                )}
                              </FormControl> */}
                            </div>
                            <div className='flex-inputcontrol-full'>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  name="numberOfEmployees"
                                  label="Number of Employess"
                                  value={formData.numberOfEmployees}
                                  onChange={(e) => handleChange(e)}
                                  type="string"
                                  className='add-vender-input-design'
                                  autoComplete='new-password'
                                  inputProps={{ autoComplete: 'new-password' }}
                                />
                              </FormControl>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  label="LinkedIn Profile"
                                  name="linkedin"
                                  value={formData.linkedin}
                                  onChange={(e) => handleChange(e)}
                                  className='add-vender-input-design'
                                  autoComplete='new-password'
                                  inputProps={{ autoComplete: 'new-password' }}
                                />
                              </FormControl>
                            </div>
                            <div className='flex-inputcontrol-full'>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  label="Country"
                                  name="country"
                                  value={formData.country}
                                  onChange={(e) => handleChange(e)}
                                  onBlur={(e) => handleChange(e)}
                                  className='add-vender-input-design'
                                  autoComplete='new-password'
                                  inputProps={{ autoComplete: 'new-password' }}
                                />
                              </FormControl>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  label="Address"
                                  name="address"
                                  value={formData.address}
                                  onChange={(e) => handleChange(e)}
                                  className='add-vender-input-design'
                                  autoComplete='new-password'
                                  inputProps={{ autoComplete: 'new-password' }}
                                />
                              </FormControl>
                            </div>
                            <FormControl fullWidth>
                              <TextField
                                name="description"
                                label="Description"
                                value={formData.description}
                                onChange={(e) => handleChange(e)}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={4}
                                className=''
                                autoComplete='new-password'
                                inputProps={{ autoComplete: 'new-password' }}
                              /></FormControl>
                          </div>
                        </div>
                        <div className='information-tab-heading'>
                          <p><img src={ProfileIcon} width={45} alt='profile icon' /> Contact Information</p>
                        </div>
                        {formData.contactInformation.map((contact, index) => (
                          <>
                            <div className='contact-information-vender-new'>
                              {index === 0 ? (<p className='primary-text-contact'>Primary Contact</p>) :
                                (<p className='primary-text-contact'>{index} Secondary Contacts</p>)
                              }
                              {index > 0 && (
                                <img className='delete-bin-icon' onClick={() => handleDeleteContact(index)} src={DeleteBin} alt='icon' style={{ cursor: 'pointer' }} />
                              )}
                            </div>

                            <div className='vendor-logoinformation'>
                              <div className='logo-vender-new'>
                              </div>
                              <div className='right-input-fields'>
                                <div className='flex-inputcontrol-full'>
                                  <FormControl fullWidth>
                                    <TextField
                                      label="First Name"
                                      name="firstName"
                                      className='add-vender-input-design'
                                      value={contact.firstName}
                                      onChange={(e) => handleContactChange(index, e)}
                                      required
                                      maxLength={30}
                                      error={!!errors[`contact-${index}-firstName`]}
                                      helperText={errors[`contact-${index}-firstName`]}
                                    />
                                  </FormControl>
                                  <FormControl fullWidth>
                                    <TextField
                                      name="lastName"
                                      variant="outlined"
                                      label="Last Name"
                                      value={contact.lastName}
                                      onChange={(e) => handleContactChange(index, e)}
                                      required
                                      maxLength={30}
                                      className='add-vender-input-design'
                                      error={!!errors[`contact-${index}-lastName`]}  // dynamic error key
                                      helperText={errors[`contact-${index}-lastName`]}
                                    />
                                  </FormControl>
                                </div>
                                <div className='flex-inputcontrol-full'>
                                  <FormControl fullWidth>
                                    <TextField
                                      name="email"
                                      variant="outlined"
                                      label="Email"
                                      value={contact.email}
                                      onChange={(e) => handleContactChange(index, e)}
                                      maxLength={40}
                                      required
                                      className='add-vender-input-design'
                                      error={!!errors[`contact-${index}-email`]}  // dynamic error key
                                      helperText={errors[`contact-${index}-email`]}
                                      InputProps={{
                                        endAdornment: <InputAdornment position="end">@{domain}</InputAdornment>,
                                      }}
                                    />
                                  </FormControl>
                                  <FormControl fullWidth>
                                    <MuiPhoneNumber
                                      dropdownClass='phone-number-drpdown'
                                      variant="outlined"
                                      className='add-vender-input-design'
                                      label="Phone Number"
                                      name="mobile"
                                      defaultCountry={"us"}
                                      value={contact.mobile}
                                      onChange={(value) => handleContactChange(index, { target: { name: "mobile", value } })}
                                      disableAreaCodes={true}
                                      fullWidth
                                      sx={{ mb: 2 }}
                                    />
                                  </FormControl>
                                </div>
                                {index === formData.contactInformation.length - 1 && (
                                  <Button variant="contained" className='addsection add-contact-button' onClick={() => handleAddContact()}>
                                    Add Another Contact
                                  </Button>
                                )}

                              </div>
                            </div>
                          </>
                        ))}

                        <div className='information-tab-heading'>
                          <p><img src={OtherInformation} width={45} alt='profile icon' /> Other Information </p>
                        </div>
                        <div className='vendor-logoinformation'>
                          <div className='logo-vender-new'>
                          </div>
                          <div className='right-input-fields'>
                            <div className='flex-inputcontrol-full'>
                              {/* <FormControl fullWidth>
                                <InputLabel id="acceptable-risk-label" shrink={formData.acceptableRisk !== ""}
                                  sx={{
                                    '&.Mui-focused': {
                                      color: document.documentType ? 'primary.main' : 'rgba(255, 255, 255, 0.7)',
                                    },
                                  }}>Select Acceptable Risk (%) </InputLabel>
                                <Select
                                  labelId="acceptable-risk-label"
                                  id="acceptable-risk"
                                  name="acceptableRisk"
                                  value={formData.acceptableRisk}
                                  onChange={(e) => handleChange(e)}
                                  required
                                  label="Acceptable Risk"
                                  error={!!errors.acceptableRisk}
                                  helperText={errors.acceptableRisk}
                                  className='add-vender-select-value'>
                                  <MenuItem value="" disabled>Acceptable Risk</MenuItem>
                                  {acceptableRiskArr.map((num) => (
                                    <MenuItem key={num} value={num}>{num}</MenuItem>
                                  ))}
                                </Select>
                                {!!errors.acceptableRisk && (
                                  <FormHelperText sx={{ color: 'red!important' }}>{errors.acceptableRisk}</FormHelperText>
                                )}
                              </FormControl> */}
                              <FormControl fullWidth>
                                <TextField
                                  name="acceptableRisk"
                                  type='number'
                                  variant="outlined"
                                  label="Acceptable Risk (0-100)"
                                  value={formData.acceptableRisk}
                                  onChange={(e) => handleChange(e)}
                                  required
                                  maxLength={30}
                                  className='add-vender-input-design'
                                  error={!!errors.acceptableRisk}  // dynamic error key
                                  helperText={errors.acceptableRisk}
                                  InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                  }}
                                />
                              </FormControl>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  className='add-vender-input-design'
                                  type="date"
                                  name="contractDeadLine"
                                  InputLabelProps={{ shrink: true }}
                                  value={formData.contractDeadline || ""}
                                  title="Select Date"
                                  label="Contract Deadline"
                                  // error={!!errors.contractDeadline}
                                  // helperText={errors.contractDeadline}
                                  // onChange={(e) => setFormData({ ...formData, contractDeadline: e.target.value })}
                                  onChange={(e) => {
                                    const selectedDate = e.target.value;
                                    setFormData({ ...formData, contractDeadline: selectedDate });

                                    // Clear error if a date is selected
                                    // if (selectedDate) {
                                    //   setErrors({ ...errors, contractDeadline: "" });
                                    // }
                                  }}
                                  inputProps={{
                                    min: getCurrentDate(new Date()),
                                    onKeyDown: (e) => e.preventDefault(),
                                    style: {
                                      WebkitAppearance: 'none',
                                      MozAppearance: 'textfield',
                                      appearance: 'none',
                                      position: 'relative',
                                    },
                                  }}
                                  sx={{ color: "white" }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <img
                                          src={CalendarTodayIcon}
                                          alt="calendar icon"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            document.getElementsByName('contractDeadLine')[0].showPicker();
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </FormControl>
                              <FormControl fullWidth>
                                <TextField
                                  variant="outlined"
                                  name="customTags"
                                  label="Custom Tags"
                                  className='add-vender-input-design'
                                  value={inputValue}
                                  onChange={(e) => setInputValue(e.target.value?.toLowerCase())}
                                  onKeyDown={(e) => handleKeyDown(e)}
                                />
                                <Box className='tags-container'>
                                  {formData.customTags.map((tag, index) => (
                                    <Chip
                                      key={index}
                                      label={tag}
                                      onDelete={() => handleDelete(tag)}
                                      style={{ margin: '4px' }}
                                    />
                                  ))}
                                </Box>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                        <Button variant="contained" color="primary" className="add-another-btn-doc next-will-space" onClick={() => handleNext()}>Next</Button>
                      </>
                    )}
                    {/*Second Tab Start*/}
                    {currentStep === 1 && (
                      <>
                        <div className='information-tab-heading'>
                          <p><img src={OtherInformation} width={45} alt='profile icon' /> Relationship  Information
                          </p>
                        </div>

                        <div className='vendor-logoinformation'>
                          <div className='logo-vender-new'>
                          </div>
                          <div className='right-input-fields'>
                            <div className='realtionship-info-tab tab-flex-realtionship'>
                              <p className='relationship-text-tag' > Relationship Risk:<span></span></p>
                              {showRiskTag && (
                                finalRelationshipRisk >= 0 && finalRelationshipRisk <= 25 ? (
                                  <span className={`tagClass Critical`}>
                                    Critical
                                  </span>
                                ) : finalRelationshipRisk > 25 && finalRelationshipRisk <= 50 ? (
                                  <span className={`tagClass High`}>
                                    High
                                  </span>
                                ) : finalRelationshipRisk > 50 && finalRelationshipRisk <= 75 ? (
                                  <span className={`tagClass Medium`}>
                                    Medium
                                  </span>
                                ) : finalRelationshipRisk > 75 && finalRelationshipRisk <= 100 ? (
                                  <span className={`tagClass Low`}>
                                    Low
                                  </span>
                                ) : (
                                  "-"
                                ))
                              }
                            </div>
                            <div className='data-sensitivity'>
                              <h3>Data Sensitivity</h3>
                              <p>What kind of data does the vendor hold?</p>
                              <div className='check-boxes-multiples'>
                                <Grid container spacing={3}>
                                  {dataSensitivityOptions.map((option) => (
                                    <Grid item xs={12} md={3} key={option}>
                                      <div className="d-flex-checks">
                                        <div className="inline-form-check checkbox-outline">
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              id="flexCheckDefault1"
                                              name="dataSensitivity"
                                              value={option}
                                              checked={formData.dataSensitivity.includes(option)}
                                              onChange={(e) => handleCheckboxChange(e, 'dataSensitivity')}
                                            />
                                            <span className="checkmark"></span>
                                            <span className="assessment-datacheck">{option}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                              {!!errors.dataSensitivity && (
                                <FormHelperText sx={{ color: 'red!important' }}>{errors.dataSensitivity}</FormHelperText>
                              )}
                            </div>
                            {/*Second copy*/}
                            <div className='data-sensitivity'>
                              <h3>Access level</h3>
                              <p>What kind of access does the vendor hold?</p>
                              <div className='check-boxes-multiples'>
                                <Grid container spacing={3} >
                                  {accessLevelOptions.map((option) => (
                                    <Grid item xs={12} md={3} key={option}>
                                      <div className="d-flex-checks">
                                        <div className="inline-form-check checkbox-outline">
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              id="flexCheckDefault1"
                                              name="accessLevel"
                                              value={option}
                                              checked={formData.accessLevel.includes(option)}
                                              onChange={(e) => handleCheckboxChange(e, 'accessLevel')}
                                            />
                                            <span className="checkmark"></span>
                                            <span className="assessment-datacheck">{option}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                              {!!errors.accessLevel && (
                                <FormHelperText sx={{ color: 'red!important' }}>{errors.accessLevel}</FormHelperText>
                              )}
                            </div>
                            {/*Dependency Level*/}
                            <div className='data-sensitivity' >
                              <h3>Dependency level</h3>
                              {/* <p>Is the vendor compliant with compliance?</p> */}
                              <p>What is company's level of dependency on the vendor?</p>
                              <div className='check-boxes-multiples'>
                                <Grid container spacing={3}>
                                  {dependencyLevelArr.map((option) => (
                                    <Grid item xs={12} md={3} key={option}>
                                      <div className="d-flex-checks">
                                        <div className="inline-form-check checkbox-outline">
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              id="flexCheckDefault1"
                                              name="dependencyLevel"
                                              value={option}
                                              checked={formData.dependencyLevel.includes(option)}
                                              onChange={(e) => handleCheckboxChange(e, 'dependencyLevel')}
                                              error={!!errors.dependencyLevel}
                                              helperText={errors.dependencyLevel}

                                            />
                                            <span className="checkmark"></span>
                                            <span className="assessment-datacheck">{option}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                              {!!errors.dependencyLevel && (
                                <FormHelperText sx={{ color: 'red!important' }}>{errors.dependencyLevel}</FormHelperText>
                              )}
                            </div>
                            {/*Compliance*/}
                            <div className='data-sensitivity'>
                              <h3>Compliance</h3>
                              <p>which complaince vendor does hold?</p>
                              <div className='check-boxes-multiples'>
                                <Grid container spacing={3}>
                                  {complianceOptions.map((option) => (
                                    <Grid item xs={12} md={3} key={option}>
                                      <div className="d-flex-checks">
                                        <div className="inline-form-check checkbox-outline">
                                          <label className="custom-checkbox">
                                            <input
                                              type="checkbox"
                                              id="flexCheckDefault1"
                                              name="complianceLevel"
                                              value={option}
                                              checked={formData.complianceLevel.includes(option)}
                                              onChange={(e) => handleCheckboxChange(e, 'complianceLevel')}
                                              error={!!errors.complianceLevel}
                                              helperText={errors.complianceLevel}
                                            />
                                            <span className="checkmark"></span>
                                            <span className="assessment-datacheck">{option}</span>
                                          </label>
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                              {!!errors.complianceLevel && (
                                <FormHelperText sx={{ color: 'red!important' }}>{errors.complianceLevel}</FormHelperText>
                              )}
                            </div>
                          </div>

                        </div>
                        {/* {!!errors[`relationshipError`] && (
                          <span style={{ color: "red", fontSize: "12px"}}>
                            {errors[`relationshipError`]}
                          </span>
                        )} */}
                        <div style={{ margin: "0px 25px 0px auto", display: "flex", width: "fit-content" }}>

                          <Button variant="contained" color="primary" className="add-another-btn-doc marin-right-another-button w120-fix" onClick={() => handleBack()}>Back</Button>
                          <Button variant="contained" color="primary" className="add-another-btn-doc w120-fix" onClick={() => handleNext()}>Next</Button>
                        </div>
                      </>
                    )}

                    {/*Third Tab Start*/}
                    {currentStep === 2 && (
                      <>
                        <div className='information-tab-heading'>
                          <p><img src={OtherInformation} width={45} alt='profile icon' /> Document Information
                          </p>
                        </div>
                        {formData.documents.map((document, index) => {
                          // Get available document types by filtering out the selected ones
                          const availableDocumentTypes = availableDocument?.filter((docType) =>
                            !formData.documents.some((doc, i) => doc.documentType === docType.name && i !== index)
                          );

                          return (
                            <>
                              <div className='vendor-logoinformation'>
                                <div className='logo-vender-new'></div>
                                <div className='upload-document-button'>
                                  <div className='flex-uploadbtn-flex'>
                                    <div className='radio-type-design'>
                                      <input
                                        type="radio"
                                        id={`upload-${index}`}
                                        name={`documentUploadRequest-${index}`}
                                        checked={document.isUpload}
                                        onChange={(e) => {
                                          const updatedDocuments = [...formData.documents];
                                          updatedDocuments[index].isUpload = e.target.checked;
                                          setFormData((prev) => ({ ...prev, documents: updatedDocuments }));
                                        }}
                                      />
                                      <label htmlFor={`upload-${index}`}>Upload Document</label>
                                    </div>
                                    {/* {console.log(jsonAvailable)} */}
                                    {/* { jsonAvailable && */}
                                    <div className='radio-type-design'>
                                      <input
                                        type="radio"
                                        id={`request-${index}`}
                                        name={`documentUploadRequest-${index}`}
                                        checked={!document.isUpload}
                                        onChange={(e) => {
                                          const updatedDocuments = [...formData.documents];
                                          updatedDocuments[index].isUpload = !e.target.checked;
                                          setFormData((prev) => ({ ...prev, documents: updatedDocuments }));
                                        }}
                                      />
                                      <label htmlFor={`request-${index}`}>Request Document</label>
                                    </div>
                                    {/* } */}
                                  </div>

                                  <div className='select-document-box-type'>
                                    <img src={DeleteBin} onClick={() => handleDeletedOC(index)} alt='icon' />
                                    <FormControl className='max-widthform-selects mb-20'>
                                      <InputLabel id={`doc-type-label-${index}`} shrink={document.documentType !== ""}
                                        sx={{
                                          '&.Mui-focused': {
                                            color: document.documentType ? 'primary.main' : 'rgba(255, 255, 255, 0.7)',
                                          },
                                        }}
                                      >Select Document Type</InputLabel>
                                      <Select
                                        labelId={`doc-type-label-${index}`}
                                        id={`doc-type-${index}`}
                                        name="documentType"
                                        value={document.documentType || ""}
                                        onChange={(e) => {
                                          const selectedDocumentType = availableDocument?.find(docType => docType.name === e.target.value);
                                          const updatedDocuments = [...formData.documents];
                                          updatedDocuments[index].documentType = selectedDocumentType.name;
                                          updatedDocuments[index].type = selectedDocumentType.type;
                                          setFormData((prev) => ({ ...prev, documents: updatedDocuments }));
                                          const updatedErrors = { ...docErrors };
                                          if (selectedDocumentType) {
                                            delete updatedErrors[`document-${index}-type`];
                                          } else {
                                            updatedErrors[`document-${index}-type`] = 'Document type is required';
                                          }

                                          setDocErrors(updatedErrors); // Update error state
                                          setFormData((prev) => ({ ...prev, documents: updatedDocuments })); // Update form data
                                        }}
                                        required
                                        label="Upload Document Type"
                                        error={!!docErrors[`document-${index}-type`]}>
                                        <MenuItem value="" disabled>Select Document Type</MenuItem>
                                        {availableDocumentTypes?.map((docType) => (
                                          <MenuItem key={docType._id} value={docType.name}>
                                            {docType.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                      {!!docErrors[`document-${index}-type`] && (
                                        <FormHelperText sx={{ color: 'red!important' }}>{docErrors[`document-${index}-type`]}</FormHelperText>
                                      )}
                                    </FormControl>
                                    {document.isUpload && (
                                      <>
                                        <FormControl className='max-widthform-selects' style={{
                                          border: "1px solid #554a8d", padding: "11px",
                                          borderRadius: "10px"
                                        }}>
                                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <label
                                              htmlFor={`file-upload-${index}`}
                                              className='label'
                                              style={{
                                                padding: "1px 11px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: "rgb(255 255 255)",
                                                color: "#000",
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Choose File
                                            </label>
                                            <span style={{ color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "200px" }}>
                                              {document.documentFile ? document.documentFile.name : "No file chosen"}
                                            </span>
                                            <input
                                              id={`file-upload-${index}`}
                                              type="file"
                                              name="documentFile"
                                              accept=".pdf"
                                              onChange={(e) => handleFileChange(e, index)}
                                              style={{ display: "none" }}
                                            />
                                          </div>
                                        </FormControl>
                                        {!!docErrors[`document-${index}-file`] && (
                                          <span style={{ color: "red", fontSize: "12px", marginLeft: "-61px", display: "block" }}>
                                            {docErrors[`document-${index}-file`]}
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className='line-top'></div>
                            </>
                          );
                        })}
                        <div style={{ margin: "15px 25px 0px auto", display: "flex", width: "fit-content", alignItems: "center" }}>
                          {formData.documents.length < availableDocument.length && <Button
                            variant="contained"
                            color="primary"
                            className="add-another-btn-doc marin-right-another-button"
                            onClick={() => {
                              const updatedDocuments = [...formData.documents, { documentType: '', isUpload: true, documentFile: null, type: '' }];
                              setFormData((prev) => ({ ...prev, documents: updatedDocuments }));
                            }}
                          >
                            Add Another Document
                          </Button>
                          }
                          <Button variant="contained" color="primary" className="add-another-btn-doc save-in" onClick={() => handleBack()}>Back</Button>
                        </div>
                      </>
                    )}

                  </div>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  className="add-another-btn-doc save-in"
                  onClick={() => handleSave()}
                  style={{ width: "175px" }}
                >
                  Add Vendor
                  {loading && roleId === "1" ? (
                    <CircularProgress size={12} sx={{ marginLeft: "15px" }} />
                  ) : null}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Container>
      </form>
      <ModalDialog
        handleClose={() => setShowExitModal(false)}
        open={showExitModal}
        onSubmit={() => navigate(-1)}
        contentData={ExitModalContent()}
      />
    </>
  )
}

export default AddNewVendorByClient